import { useTranslation } from 'react-i18next'

import { Flex, Icon, Skeleton } from '@percent/lemonade'
import classes from './FilterButton.module.scss'

type FiltersButtonProps = {
  onClick: VoidFunction
  activeFiltersAmount?: number
  testId?: string
  isLoading?: boolean
}

export function FiltersButton({ onClick, activeFiltersAmount, testId, isLoading }: Readonly<FiltersButtonProps>) {
  const { t } = useTranslation()

  if (isLoading) {
    return <Skeleton variant="rectangular" width={85} height={20} />
  }

  return (
    <button type="button" onClick={onClick} className={classes.filtersBtn} data-testid={testId}>
      <Flex direction="row" gap={4} align="center">
        <Icon name="filters" size={6} color="gray600" />
        <span className={classes.btnText}>{t('workplace_giving.common.filters')}</span>
        {activeFiltersAmount ? <span className={classes.filtersCounter}>{activeFiltersAmount}</span> : null}
      </Flex>
    </button>
  )
}
